import React, { FC, memo } from 'react'
import goTackleLogo from 'assets/images/GoTackle-Logo.svg'
import { Tool } from '__generated__/api-types-and-hooks'
import {
  ToolFlyoutHeaderSidebarTextWrapper,
  ToolFlyoutHeaderSidebarWrapper,
  ToolFlyoutHeaderSidebarCategoryWrapper,
} from 'components/Owner/Tools/ToolFlyout/style'

export interface IToolFlyoutHeaderSidebarProps {
  toolDetail: Tool
}

const ToolFlyoutHeaderSidebar: FC<IToolFlyoutHeaderSidebarProps> = ({ toolDetail }) => {
  return (
    <ToolFlyoutHeaderSidebarWrapper>
      {toolDetail.isRecommended && (
        <div>
          <ToolFlyoutHeaderSidebarTextWrapper>Backed by</ToolFlyoutHeaderSidebarTextWrapper>
          <img
            src={goTackleLogo}
            alt="GoTackle icon"
            className="object-contain w-[70px] pt-2 pb-7"
          />
        </div>
      )}
      <div>
        <ToolFlyoutHeaderSidebarTextWrapper>Category</ToolFlyoutHeaderSidebarTextWrapper>
        <ToolFlyoutHeaderSidebarCategoryWrapper>
          {toolDetail.category}
        </ToolFlyoutHeaderSidebarCategoryWrapper>
      </div>
    </ToolFlyoutHeaderSidebarWrapper>
  )
}

export default memo(ToolFlyoutHeaderSidebar)
